import { render, staticRenderFns } from "./verify-code.vue?vue&type=template&id=f14aeacc&scoped=true"
import script from "./verify-code.vue?vue&type=script&lang=js"
export * from "./verify-code.vue?vue&type=script&lang=js"
import style0 from "./verify-code.vue?vue&type=style&index=0&id=f14aeacc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14aeacc",
  null
  
)

export default component.exports